export const ENGINE_VERSION = '0.3.0';

/** Bumped whenever GameState shape changes; save migrations key off this (ARCHITECTURE 5.7). */
export const STATE_SCHEMA_VERSION = 1;
